import React, { useEffect, useState } from 'react';
import { FrownOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { useNavigate, useRouteError } from 'react-router-dom';
import {
    isDynamicImportFailure,
    reloadOnceWithCacheBuster,
} from '../../utils/staleChunkRecovery';
import { ErrorContainer, ErrorDescription, ErrorMessage } from './styles';

const PageError = () => {
    const navigate = useNavigate();
    const routeError = useRouteError();

    const [recovering, setRecovering] = useState(() =>
        isDynamicImportFailure(routeError),
    );

    useEffect(() => {
        if (!isDynamicImportFailure(routeError)) return undefined;

        const didReload = reloadOnceWithCacheBuster();

        if (!didReload) {
            setRecovering(false);
            return undefined;
        }

        /**
         * `location.replace` should unmount this component almost
         * immediately. This timeout is only a safety net in case the
         * navigation is somehow blocked, so the user is never stuck on the
         * "updating" screen with no way out.
         */
        const fallbackTimeout = setTimeout(() => setRecovering(false), 4000);

        return () => clearTimeout(fallbackTimeout);
    }, [routeError]);

    const handleGoBack = () => {
        navigate(-1);
    };

    if (recovering) {
        return (
            <ErrorContainer>
                <SyncOutlined
                    spin
                    style={{
                        fontSize: 64,
                        color: '#1677ff',
                        marginBottom: 16,
                    }}
                />
                <ErrorMessage>Atualizando o sistema...</ErrorMessage>
                <ErrorDescription>
                    Uma nova versão foi publicada. Estamos atualizando a página
                    automaticamente.
                </ErrorDescription>
            </ErrorContainer>
        );
    }

    return (
        <ErrorContainer>
            <FrownOutlined
                style={{
                    fontSize: 64,
                    color: '#ff4d4f',
                    marginBottom: 16,
                }}
            />
            <ErrorMessage>Ops! Algo deu errado.</ErrorMessage>
            <ErrorDescription>
                Não se preocupe! Vamos tentar corrigir isso. Por favor, volte ao
                início.
            </ErrorDescription>
            <Space style={{ marginTop: 20 }}>
                <Button onClick={handleGoBack}>Voltar</Button>
            </Space>
        </ErrorContainer>
    );
};

export default PageError;
